import React, { useState } from 'react';
import { Card, Form, Input, Button, message, Typography } from 'antd';
import { UserOutlined, LockOutlined, ShopOutlined } from '@ant-design/icons';
import { useAuth } from '../auth.jsx';

const { Title, Text } = Typography;

export default function Login() {
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);

  const [guestLoading, setGuestLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        message.success(`欢迎回来，${data.user.name}！`);
        login(data.token, data.user);
      } else {
        message.error(data.error || '登录失败');
        setLoading(false);
      }
    } catch (err) {
      message.error('网络错误，请稍后重试');
      setLoading(false);
    }
  };

  // 游客免登录进入（仅盈亏计算器）
  const handleGuest = async () => {
    setGuestLoading(true);
    try {
      const res = await fetch('/api/guest-login', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
      const data = await res.json();
      if (res.ok && data.success) {
        login(data.token, data.user);
      } else {
        message.error(data.error || '进入失败');
        setGuestLoading(false);
      }
    } catch (err) {
      message.error('网络错误，请稍后重试');
      setGuestLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(160deg, var(--brand-hover) 0%, var(--brand-soft) 45%, var(--brand-bg) 100%)',
      position: 'relative',
    }}>
      <Card style={{
        width: 420, borderRadius: 20, border: '0.5px solid var(--brand-border)',
        background: '#ffffff', boxShadow: '0 12px 40px rgba(var(--brand-rgb),0.12)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{
            width: 72, height: 72, margin: '0 auto 16px', borderRadius: 20,
            background: 'linear-gradient(135deg,var(--grad-from),var(--brand))', display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 8px 20px rgba(var(--brand-rgb),0.35)',
          }}>
            <ShopOutlined style={{ fontSize: 36, color: '#fff' }} />
          </div>
          <Title level={3} style={{ margin: 0, marginBottom: 4, color: '#333' }}>电商管理工作台</Title>
          <Text style={{ color: '#999' }}>订单 · 物流 · 库存 · 财务 一站式管理</Text>
        </div>

        <Form onFinish={handleSubmit} size="large" autoComplete="off">
          <Form.Item name="username" rules={[{ required: true, message: '请输入用户名' }]}>
            <Input prefix={<UserOutlined style={{ color: 'var(--brand)' }} />} placeholder="用户名" style={{ borderRadius: 10, background: '#FAF7F5', borderColor: 'var(--brand-border)' }} />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockOutlined style={{ color: 'var(--brand)' }} />} placeholder="密码" style={{ borderRadius: 10, background: '#FAF7F5', borderColor: 'var(--brand-border)' }} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}
              style={{ height: 46, borderRadius: 10, fontWeight: 700, boxShadow: '0 4px 12px rgba(var(--brand-rgb),0.3)' }}>
              登 录
            </Button>
          </Form.Item>
        </Form>
        <div style={{ margin: '8px 0 4px' }}>
          <Button block size="large" loading={guestLoading}
            style={{ height: 44, borderRadius: 10, background: 'var(--brand-soft)', borderColor: 'var(--brand)', color: 'var(--brand-strong)', fontWeight: 600 }}
            onClick={handleGuest}>
            游客进入（仅盈亏计算器）
          </Button>
        </div>
        <div style={{ textAlign: 'center', marginTop: 8, color: '#C0B4A8', fontSize: 12 }}>酒店用品发货订单管理 · 本地部署</div>
      </Card>
    </div>
  );
}
